export default {
  computed: {
    isClassMode() {
      return this.$store.state.classMode.enabled;
    },
    isClassModeCreator() {
      return this.$store.state.classMode.isCreator;
    },
  },
  methods: {
    colorClass(i, text) {
      const colorClass = [
        'teal',
        'orange',
        'primary',
        'success',
      ];

      return (text) ? `${colorClass[i]}--text` : colorClass[i];
    },
  },
};
